module.exports = __webpack_public_path__ + "static/img/admin.1554886d.jpg";